import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import Accordion from '@r1-frontend/ui-react/deprecated/Accordion';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const Wrapper = styled.section`
    display: block;
    width: 100%;
    padding-top: 64px;
    padding-bottom: 64px;
    background-color: ${COLORS.BgMain};
`;

export const HeadTitle = styled.h2`
    ${FONTS.H2};
    color: ${COLORS.TextPrimary};
    margin-bottom: 32px;

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        ${FONTS.H3};
        margin-bottom: 24px;
    }

    @media (max-width: ${wideBreakpoints.laptop}) {
        margin-bottom: 8px;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        ${FONTS.H2};
    }
`;

export const SAccordion = styled(Accordion)`
    margin-bottom: 16px;
    border-radius: ${BorderRadius.OuterBlockRadius};
`;

export const TextLine = styled.p`
    margin-bottom: 12px;
    width: 100%;

    &:last-child {
        margin-bottom: 0;
    }
`;
